import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getTenantFeatures } from '../lib/api';

/**
 * Coaching master-switch guard: when `coaching_enabled` is off the coach app
 * does not exist for this tenant, so its admin page does not either — bounce
 * to the dashboard rather than render an empty shell (the sidebar entry is
 * hidden too; this catches deep links).
 */
export function RequireCoaching({ children }: { children: React.ReactNode }) {
  const featuresQuery = useQuery({
    queryKey: ['tenant-features'],
    queryFn: getTenantFeatures,
    staleTime: 60_000,
    retry: false,
  });
  if (featuresQuery.isLoading) return null;
  if (featuresQuery.data?.coaching_enabled !== true) return <Navigate to="/" replace />;
  return <>{children}</>;
}
